import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { filter } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { Authentication } from '../../services/authentication.service';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { NotificationService } from '../../services/notification.service';
import { AccountService } from '../../services/account.service';
import { TitleService } from '../../services/title.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  userName: any;
  password: any = '';
  valid = true;
  show_eye = false;
  verified: any;
  unauthorized: any;
  validEmail = true;

  contactEmail = `info@terminologyhub.com`;

  noAccount = false;
  emailExist = false;
  emailVerified = false;

  emailFC = new FormControl('', [Validators.required]);
  passwordFC = new FormControl('', [Validators.required]);

  constructor(
    private authService: Authentication,
    private accountService: AccountService,
    private router: Router,
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private errorHandlingService: ErrorHandlingService,
    private notificationService: NotificationService,
    private titleService: TitleService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setTabTitle();
    });
    // IF logged in already, just go to automap
    if (this.authService.isTokenValid()) {
      this.router.navigate(['automap']);
    }
  }
  setTabTitle() {
    this.titleService.setTitle(this.route.snapshot, this.router.routerState.snapshot);
  }
  onSubmit(): any {
    this.unauthorized = false;
    this.userName = this.emailFC.value;
    this.password = this.passwordFC.value;
    if (this.userName === '' || this.userName === undefined || this.userName === null) {
      this.errorHandlingService.showError('User Name can not be empty');
      return;
    }
    if (this.password === '' || this.password === undefined || this.password === null) {
      this.errorHandlingService.showError('Password can not be empty');
      return;
    }
    this.ngxLoader.start();
    this.authService.login(this.userName.toLowerCase(), this.password).subscribe(
      (response) => {
        this.authService.successAuthentication(response);
      },
      (error) => {
        this.unauthorized = true;
        if (error.status === 417) {
          this.errorHandlingService.showError('Login expectation failed, contact provider');
          this.noAccount = false;
          this.emailExist = true;
          this.emailVerified = false;
        }
        if (error.status === 401) {
          this.errorHandlingService.showError('Username or password is incorrect');
          this.noAccount = true;
          this.emailExist = false;
          this.emailVerified = false;
        } else {
          this.authService.errorAuthentication(error);
        }
      },
    );
  }

  validateEmail() {
    this.noAccount = false;
    this.emailExist = false;
    this.emailVerified = false;
  }

  verifyEmail() {
    /* eslint-disable-next-line */
    if (/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(this.userName)) {
      this.validEmail = true;
    } else {
      this.validEmail = false;
    }
    this.validateEmail();
  }

  resendVerificationEmail(): any {
    this.ngxLoader.start();
    this.accountService.resendVerificationEmail(this.userName.toLowerCase()).subscribe(
      (data) => {
        this.ngxLoader.stop();
        this.notificationService.showSuccess('Verification email resent to ' + this.userName);
      },
      (err) => {
        this.ngxLoader.stop();
        return this.errorHandlingService.handleError(err, err.url);
      },
    );
  }
  resetPassword(): any {
    this.ngxLoader.start();
    this.accountService.reset(this.userName.toLowerCase()).subscribe(
      (data) => {
        this.ngxLoader.stop();
        this.notificationService.showSuccess('Verification email resent to ' + this.userName);
      },
      (err) => {
        this.ngxLoader.stop();
        this.errorHandlingService.handleError(err, err.url);
        if (err.error.status === 417) {
          this.valid = false;
        }
      },
    );
  }

  showPassword(show) {
    this.show_eye = show;
  }

  ngOnInit(): void {
    this.setTabTitle();
    this.userName = this.route.snapshot.queryParamMap.get('username');
    this.emailFC.setValue(this.userName);
    this.verified = this.route.snapshot.queryParamMap.get('verified');
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com/automap';
  }
}
